import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { StateSwitcher } from 'containers/misc'
import { RP_PROGRESS_STATES } from 'constants/enums'

export default class RpState extends Component {
  static propTypes = {
    rpId: PropTypes.number.isRequired,
    rpState: PropTypes.object.isRequired,
    changeRpChange: PropTypes.func.isRequired,
    rpApproval: PropTypes.object.isRequired,
    rpSignoff: PropTypes.object.isRequired
  }
  static defaultProps = {
    rpState: {}
  }

  render() {
    const { rpState, changeRpChange, rpId, rpApproval, rpSignoff } = this.props

    const disabledStates = [
      RP_PROGRESS_STATES.rpOfficeSignoff.id,
      RP_PROGRESS_STATES.rpCeremonySignoff.id,
      RP_PROGRESS_STATES.rpComplete.id,
      RP_PROGRESS_STATES.rpInactive.id
    ]

    const states = {
      [RP_PROGRESS_STATES.rpSetup.id]: {
        id: RP_PROGRESS_STATES.rpSetup.id,
        label: 'Setup',
        intlKey: 'states.setup',
        content: null,
        disabledStates: ['DISABLED']
      },
      [RP_PROGRESS_STATES.rpApproval.id]: {
        id: RP_PROGRESS_STATES.rpApproval.id,
        label: 'Approval',
        intlKey: 'states.approval',
        content: rpApproval,
        disabledStates: ['DISABLED']
      },
      [RP_PROGRESS_STATES.rpInProgress.id]: {
        id: RP_PROGRESS_STATES.rpInProgress.id,
        label: 'In progress',
        intlKey: 'states.in_progress',
        content: null,
        disabledStates: [
          RP_PROGRESS_STATES.rpSetup.id,
          RP_PROGRESS_STATES.rpLeaderSignoff.id,
          ...disabledStates
        ]
      },
      [RP_PROGRESS_STATES.rpAssessorApproval.id]: {
        id: RP_PROGRESS_STATES.rpAssessorApproval.id,
        label: 'Assessor approval',
        intlKey: 'states.assessor_approval',
        content: null,
        disabledStates: [
          RP_PROGRESS_STATES.rpSetup.id,
          RP_PROGRESS_STATES.rpApproval.id,
          ...disabledStates
        ]
      },
      [RP_PROGRESS_STATES.rpLeaderSignoff.id]: {
        id: RP_PROGRESS_STATES.rpLeaderSignoff.id,
        label: 'Awaiting Sign-off',
        intlKey: 'states.awaiting_sign_off',
        content: rpSignoff,
        disabledStates: ['DISABLED']
      },
      [RP_PROGRESS_STATES.rpOfficeSignoff.id]: {
        id: RP_PROGRESS_STATES.rpOfficeSignoff.id,
        label: 'Awaiting Office Sign-off',
        intlKey: 'states.awaiting_office_sign_off',
        content: null,
        disabledStates: [
          RP_PROGRESS_STATES.rpSetup.id,
          RP_PROGRESS_STATES.rpApproval.id,
          RP_PROGRESS_STATES.rpAssessorApproval.id,
          RP_PROGRESS_STATES.rpInProgress.id,
          ...disabledStates
        ]
      },
      [RP_PROGRESS_STATES.rpComplete.id]: {
        id: RP_PROGRESS_STATES.rpComplete.id,
        label: 'Completed',
        intlKey: 'states.completed',
        content: null,
        disabledStates: ['DISABLED']
      },
      [RP_PROGRESS_STATES.rpCeremonySignoff.id]: {
        id: RP_PROGRESS_STATES.rpCeremonySignoff.id,
        label: 'Ceremony',
        intlKey: 'states.ceremony_certificate',
        content: null,
        disabledStates: ['DISABLED']
      },
      [RP_PROGRESS_STATES.rpInactive.id]: {
        id: RP_PROGRESS_STATES.rpInactive.id,
        label: 'Inactive',
        intlKey: 'states.inactive',
        content: null,
        disabledStates: ['DISABLED']
      }
    }

    return (
      <StateSwitcher
        id={rpId}
        state={rpState}
        states={states}
        changeState={changeRpChange}
      />
    )
  }
}
